import { Linkedin, Instagram, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-white border-t border-slate-200">
      <div className="container-eos py-16 lg:py-20">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12">
          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="flex flex-col leading-none">
              <span className="font-display font-extrabold text-2xl tracking-tight text-navy-800">
                Carlos Garcín
              </span>
              <span className="mt-1 text-[11px] font-bold tracking-[0.18em] uppercase text-[#F26522]">
                Professional EOS Implementer
              </span>
            </div>
            <p className="mt-5 text-slate-600 leading-relaxed max-w-md">
              Impulsando empresas más enfocadas, alineadas y saludables en Chile y Latinoamérica.
            </p>
          </div>

          {/* Columns */}
          <div className="lg:col-span-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">

            {/* Navegación */}
            <div>
              <p className="text-xs font-bold tracking-[0.22em] uppercase text-navy-800">Navegación</p>
              <ul className="mt-5 space-y-3">
                {[
                  { label: "¿Qué es EOS?", to: "/que-es-eos" },
                  { label: "El modelo", to: "/el-modelo-eos" },
                  { label: "El proceso", to: "/implementacion" },
                  { label: "Rompiendo el techo", to: "/rompiendo-el-techo" },
                  { label: "Testimonios", to: "/testimonios-eos" },
                  { label: "Dolores del Empresario", to: "/dolores-del-empresario" },
                  { label: "Preguntas frecuentes", to: "/faq" },
                  { label: "Implementador EOS", to: "/implementador-eos" },
                ].map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-slate-600 hover:text-[#F26522] transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link
                    to="/contacto"
                    data-testid="footer-link-contacto"
                    className="text-sm text-slate-600 hover:text-[#F26522] transition-colors"
                  >
                    Contacto
                  </Link>
                </li>
              </ul>
            </div>

            {/* Recursos SEO */}
            <div>
              <p className="text-xs font-bold tracking-[0.22em] uppercase text-navy-800">Recursos</p>
              <ul className="mt-5 space-y-3">
                {[
                  { label: "Eficiencia Operativa", to: "/eficiencia-operativa-empresas" },
                  { label: "EOS vs OKR", to: "/eos-vs-okr" },
                  { label: "EOS para PYMEs", to: "/eos-para-pymes" },
                  { label: "Empresas Familiares", to: "/eos-empresas-familiares" },
                  { label: "Empresas Tech", to: "/eos-empresas-tecnologia" },
                  { label: "La Biblioteca EOS", to: "/libros-eos" },
                  { label: "Historia de EOS", to: "/historia-eos" },
                ].map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-recursos-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      className="text-sm text-slate-600 hover:text-[#F26522] transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Países */}
            <div>
              <p className="text-xs font-bold tracking-[0.22em] uppercase text-navy-800">Países</p>
              <ul className="mt-5 space-y-3">
                {[
                  { label: "Chile", to: "/eos-en-chile" },
                  { label: "Perú", to: "/eos-peru" },
                  { label: "Colombia", to: "/eos-colombia" },
                  { label: "Argentina", to: "/eos-argentina" },
                  { label: "Uruguay", to: "/eos-uruguay" },
                  { label: "Ecuador", to: "/eos-ecuador" },
                  { label: "Paraguay", to: "/eos-paraguay" },
                ].map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-pais-${l.label.toLowerCase()}`}
                      className="text-sm text-slate-600 hover:text-[#F26522] transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Enlaces */}
            <div>
              <p className="text-xs font-bold tracking-[0.22em] uppercase text-navy-800">Enlaces</p>
              <ul className="mt-5 space-y-3">
                <li>
                  <a
                    href="https://www.linkedin.com/in/cgarcin-cl/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-link-linkedin"
                    className="flex items-center gap-2 text-sm text-slate-600 hover:text-[#F26522] transition-colors"
                  >
                    <Linkedin className="w-4 h-4 shrink-0" strokeWidth={1.8} />
                    LinkedIn
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/implementador_eos"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-link-instagram"
                    className="flex items-center gap-2 text-sm text-slate-600 hover:text-[#F26522] transition-colors"
                  >
                    <Instagram className="w-4 h-4 shrink-0" strokeWidth={1.8} />
                    Instagram
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/@implementador_eos"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-link-youtube"
                    className="flex items-center gap-2 text-sm text-slate-600 hover:text-[#F26522] transition-colors"
                  >
                    <Youtube className="w-4 h-4 shrink-0" strokeWidth={1.8} />
                    YouTube
                  </a>
                </li>
                <li>
                  <a
                    href="https://implementer.eosworldwide.com/carlos-garcin/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-link-eos-micrositio"
                    className="text-sm text-slate-600 hover:text-[#F26522] transition-colors"
                  >
                    EOS micro-sitio oficial
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.eosworldwide.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-link-eos-oficial"
                    className="text-sm text-slate-600 hover:text-[#F26522] transition-colors"
                  >
                    EOS oficial
                  </a>
                </li>
              </ul>
            </div>

          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {year} Carlos Garcín · Professional EOS Implementer. Todos los derechos reservados.
          </p>
          <p className="text-xs text-slate-400">
            EOS<sup className="text-[8px]">®</sup> · Entrepreneurial Operating System<sup className="text-[8px]">®</sup>
          </p>
        </div>
      </div>
    </footer>
  );
}
